import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, authCodeScopesCheck, paramCheckErrno } from '../utils';
import { ApiErrno, errnoCategory1, errnoCategory2, errorType } from 'src/shared/errno';

export interface GetAutoCodeOption extends Partial<GeneralInvokeOption> {
  scopes: Array<string>;
  invalidParamObj?: '';
}

// 获取登录凭证
export function getAuthCode(option: GetAutoCodeOption) {
  if (!option.scopes) {
    return logErrorAndRunFail(
      APINames.Native.GET_AUTH_CODE,
      option,
      `parameter error: parameter.scopes is necessary, please check input param.`,
      ApiErrno.Errno(errnoCategory1.COMMON, errnoCategory2.COMMON, errorType.MISSING_PARAM)
    );
  }
  // 校验参数scopes的类型，并返回相应错误码
  if (paramCheckErrno(APINames.Native.GET_AUTH_CODE, option, { scopes: ['1'] })) {
    const invalidScopes = authCodeScopesCheck(option.scopes);
    if (invalidScopes.length > 0) {
      return logErrorAndRunFail(
        APINames.Native.GET_AUTH_CODE,
        option,
        `parameter error: invalid scopes ${invalidScopes}`,
        ApiErrno.Errno(errnoCategory1.COMMON, errnoCategory2.COMMON, errorType.INVALID_VALUE)
      );
    }
    return MacleJSBridge.beforeInvoke(APINames.Native.GET_AUTH_CODE, option);
  }
  return option.invalidParamObj;
}
